import { Link } from "react-router-dom";
import { Phone, Mail } from "lucide-react";
import { services } from "@/data/services";
import { cities } from "@/data/cities";
import { NSLogo, CONTACT } from "./NSLogo";
import { TID } from "@/lib/testIds";

export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer
      data-testid={TID.footer.root}
      className="bg-[#111111] text-[#F5F3EF] pt-24 pb-10 relative overflow-hidden"
    >
      <div className="max-w-[1600px] mx-auto px-6 lg:px-12">
        {/* Massive wordmark */}
        <div className="border-b border-[#2A2A2A] pb-10 mb-16">
          <p className="font-serif italic text-[clamp(3rem,10vw,10rem)] leading-[0.9] tracking-tighter text-[#F5F3EF]">
            Stand watch.
          </p>
          <p className="font-serif italic text-[clamp(3rem,10vw,10rem)] leading-[0.9] tracking-tighter text-[#C17A43]/80 -mt-4">
            Every hour.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-12 gap-10 mb-16">
          <div className="md:col-span-4">
            <NSLogo dark testid="footer-logo" />
            <p className="mt-6 font-sans text-sm leading-relaxed text-[#F5F3EF]/70 max-w-[36ch]">
              Nova Scotia Security Services, a {CONTACT.parentBrand} division —
              the province&apos;s editorial-grade security partner, deployed
              across mining, marine, corporate, event and residential contracts
              from Yarmouth to Sydney.
            </p>
            <div className="mt-8 flex flex-col gap-3">
              <a
                href={CONTACT.phoneHref}
                data-testid="footer-phone"
                className="group inline-flex items-center gap-3 font-mono text-[12px] uppercase tracking-[0.22em] text-[#F5F3EF] hover:text-[#C17A43] transition-colors"
              >
                <Phone size={14} strokeWidth={1.5} className="text-[#C17A43]" />
                {CONTACT.phone}
              </a>
              <a
                href={CONTACT.emailHref}
                data-testid="footer-email"
                className="group inline-flex items-center gap-3 font-mono text-[12px] normal-case tracking-[0.08em] text-[#F5F3EF] hover:text-[#C17A43] transition-colors"
              >
                <Mail size={14} strokeWidth={1.5} className="text-[#C17A43]" />
                {CONTACT.email}
              </a>
            </div>
            <p className="mt-8 font-mono text-[10px] uppercase tracking-[0.24em] text-[#F5F3EF]/50">
              Licensed under the Security & Investigative Services Act (NS)
            </p>
          </div>

          <div className="md:col-span-4">
            <p className="font-mono text-[11px] uppercase tracking-[0.24em] text-[#C17A43] mb-6">
              — Services
            </p>
            <ul className="grid grid-cols-1 gap-2">
              {services.map((s) => (
                <li key={s.slug}>
                  <Link
                    to={`/services/${s.slug}`}
                    className="font-serif text-lg text-[#F5F3EF] hover:text-[#C17A43] hover:italic transition-colors duration-300"
                  >
                    {s.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-4">
            <p className="font-mono text-[11px] uppercase tracking-[0.24em] text-[#C17A43] mb-6">
              — Cities Covered
            </p>
            <ul className="grid grid-cols-2 gap-x-4 gap-y-1.5">
              {cities.slice(0, 30).map((c) => (
                <li key={c.slug}>
                  <Link
                    to={`/cities/${c.slug}`}
                    className="font-sans text-[13px] text-[#F5F3EF]/80 hover:text-[#C17A43] transition-colors"
                  >
                    {c.name}
                  </Link>
                </li>
              ))}
            </ul>
            <Link
              to="/cities"
              className="inline-block mt-4 font-mono text-[10px] uppercase tracking-[0.24em] text-[#F5F3EF]/70 hover:text-[#C17A43]"
            >
              View all {cities.length} cities →
            </Link>
          </div>
        </div>

        <div className="border-t border-[#2A2A2A] pt-8 flex flex-col md:flex-row justify-between items-start md:items-center gap-4">
          <p className="font-mono text-[10px] uppercase tracking-[0.24em] text-[#F5F3EF]/50">
            © {year} Nova Scotia Security Services · All rights reserved
          </p>
          <p className="font-mono text-[10px] uppercase tracking-[0.24em] text-[#F5F3EF]/50">
            Halifax · Dartmouth · Sydney · Truro · New Glasgow · Yarmouth · Bridgewater
          </p>
        </div>
      </div>
    </footer>
  );
}
